export const groundLevel = 0.4;
export const sceneColor = 0x87c6ff;
export const startingRow = 8;
export const maxRows = 20;
export const disableDriftwood = false;
export const CAMERA_EASING = 0.03;
export const MAP_OFFSET = -30;
export const BASE_ANIMATION_TIME = 0.1;
export const IDLE_DURING_GAME_PLAY = false;
export const PI_2 = Math.PI * 0.5;
export const PLAYER_IDLE_SCALE = 0.8;
export const DEBUG_CAMERA_CONTROLS = false;
export const realTimeToGameTimeRatio = 2;
export const itemGenerationRate = 1;
export const MUTED = true;
export const explosionDuration = 0.2;
export const DISABLE_ITEMS = false;
